module.exports = __webpack_public_path__ + "img/7diamante.58d872f0.png";